module.exports = __webpack_public_path__ + "static/media/car_on.e02f01dc.png";